import { createRouter, createWebHistory } from "vue-router";
import Home from "@/views/Home.vue";
import About from "@/views/About.vue";
import Subprogram from "@/views/Subprogram.vue";
import Projects from "@/views/Projects.vue";
import Laboratory from "@/views/Laboratory.vue";
import NotFound from "@/views/NotFound.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/acerca-de",
    name: "Acerca de",
    component: About
  },
  {
    path: "/subprogramas/:subprogram",
    name: "Subprogram",
    component: Subprogram
  },
  {
    path: "/proyectos/:type",
    name: "Projects",
    component: Projects
  },
  {
    path: "/laboratorio/:laboratory/:section",
    name: "Laboratory",
    component: Laboratory
  },
  {
    path: "/:catchAll(.*)",
    name: "404",
    component: NotFound
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
